import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { selectedBomIdsSelector } from "../../../../../features/certificateOfOrigin/certificateOfOriginSlice";
import useBomList from "../../../../../hooks/useBomList";

export default function useQualifiedBills() {
  const selectedBomIds = useSelector(selectedBomIdsSelector);
  const [selectedBoms, setSelectedBoms] = useState([]);
  const [loading, setLoading] = useState(true);
  const { completedOnly: allBoms, isLoading } = useBomList();

  useEffect(() => {
    if (allBoms && allBoms && Array.isArray(allBoms) && allBoms.length > 0) {
      setSelectedBoms(allBoms.filter((bom) => selectedBomIds.indexOf(bom.BOMID) !== -1));
    } else {
      setSelectedBoms([]);
    }

    return () => setSelectedBoms([]);
  }, [allBoms, selectedBomIds]);

  useEffect(() => {
    if (isLoading && !selectedBoms) {
      setLoading(true);
    } else {
      setLoading(false);
    }

    return () => setLoading(false);
  }, [isLoading, selectedBoms]);

  return useMemo(() => ({ selectedBoms, loading }), [selectedBoms, loading]);
}
